import coreHelper from "@/utils/coreHelper";
import apiService from "./apiService";

const clientService = {
    async search(searchModel) {
        try {
            const resp = await apiService.get(`clients/adv-search`, searchModel, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async getClientInfo(id) {
        try {
            const resp = await apiService.get(`clients/${id}/get-full-info`, {}, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async update(client) {
        try {
            const resp = await apiService.post(`clients/save`, client, true);
            return resp.data;
        }
        catch {
            return coreHelper.createGenericResponseError();
        }
    },
    async deactivate(id) {
        try {
            const resp = await apiService.put(`clients/${id}/deactivate`, {}, true);
            return resp.data;
        }
        catch {
            return coreHelper.createGenericResponseError();
        }
    },
    async activate(id) {
        try {
            const resp = await apiService.put(`clients/${id}/activate`, {}, true);
            return resp.data;
        }
        catch {
            return coreHelper.createGenericResponseError();
        }
    },
    async getMTActiveClients() {
        try {
            const resp = await apiService.get(`clients/get-mt-active-clients`, {}, true);
            return resp.data;
        }
        catch {
            return [];
        }
    },
    async removeFromActive(id, server) {
        try {
            const resp = await apiService.put(`clients/remove-from-mt-active`, {id: id, server: server}, true);
            return resp.data;
        }
        catch {
            return coreHelper.createGenericResponseError();
        }
    }
}

export default clientService;